import useReactQuery from '@/hooks/common/useReactQuery';
import { type OrganizationMembershipValidationResponse } from '@/interfaces/registration';

interface Props {
  organizationMembershipCode: string;
  studentFirstNameKana?: string;
  studentLastNameKana?: string;
}

interface ErrorResponse {
  status: number;
  error_code: string;
  json: {
    error_code: string | null;
    message: string | null;
  };
}

interface RefetchResult {
  data?: OrganizationMembershipValidationResponse;
  error?: ErrorResponse;
}

const useStudentInfo = ({
  organizationMembershipCode,
  studentFirstNameKana,
  studentLastNameKana,
}: Props) => {
  const { useMutation } = useReactQuery();

  const {
    mutateAsync: mutateAsyncV2,
    isPending: isPendingV2,
    error: errorV2,
  } = useMutation<OrganizationMembershipValidationResponse>({
    method: 'POST',
    url: '/api/school/organization_membership_validations_v2/validate',
  });

  return {
    isLoading: isPendingV2,
    error: errorV2,
    refetch: async (): Promise<RefetchResult> => {
      try {
        const data = await mutateAsyncV2(
          JSON.stringify({
            code: organizationMembershipCode,
            first_name_kana: studentFirstNameKana,
            last_name_kana: studentLastNameKana,
          }),
        );
        return { data, error: undefined };
      } catch (error) {
        return { data: undefined, error: error as ErrorResponse };
      }
    },
  };
};

export default useStudentInfo;
